var map = {
	"../accounts/accounts.module": [
		"./src/app/pages/accounts/accounts.module.ts",
		"accounts-accounts-module"
	],
	"../chat/chat.module": [
		"./src/app/pages/chat/chat.module.ts",
		"common",
		"chat-chat-module"
	],
	"../chats/chats.module": [
		"./src/app/pages/chats/chats.module.ts",
		"chats-chats-module"
	],
	"../cloods/cloods.module": [
		"./src/app/pages/cloods/cloods.module.ts",
		"common",
		"cloods-cloods-module"
	],
	"../donate/select-charity/select-charity.module": [
		"./src/app/pages/donate/select-charity/select-charity.module.ts",
		"common",
		"donate-select-charity-select-charity-module"
	],
	"../friends/friends.module": [
		"./src/app/pages/friends/friends.module.ts",
		"friends-friends-module"
	],
	"../greetings/greetings.module": [
		"./src/app/pages/greetings/greetings.module.ts",
		"common",
		"greetings-greetings-module"
	],
	"../profile/profile.module": [
		"./src/app/pages/profile/profile.module.ts",
		"profile-profile-module"
	],
	"../settings/settings.module": [
		"./src/app/pages/settings/settings.module.ts",
		"settings-settings-module"
	],
	"../transfer-to/transfer-to.module": [
		"./src/app/pages/transfer-to/transfer-to.module.ts",
		"common",
		"transfer-to-transfer-to-module"
	],
	"../user-profile/user-profile.module": [
		"./src/app/pages/user-profile/user-profile.module.ts",
		"user-profile-user-profile-module"
	],
	"./coming-soon/coming-soon.module": [
		"./src/app/coming-soon/coming-soon.module.ts",
		"coming-soon-coming-soon-module"
	],
	"./pages/accounts/accounts.module": [
		"./src/app/pages/accounts/accounts.module.ts",
		"accounts-accounts-module"
	],
	"./pages/agenda/agenda.module": [
		"./src/app/pages/agenda/agenda.module.ts",
		"pages-agenda-agenda-module"
	],
	"./pages/allergy/allergy.module": [
		"./src/app/pages/allergy/allergy.module.ts",
		"pages-allergy-allergy-module"
	],
	"./pages/amount/amount.module": [
		"./src/app/pages/amount/amount.module.ts",
		"pages-amount-amount-module"
	],
	"./pages/chat/chat.module": [
		"./src/app/pages/chat/chat.module.ts",
		"common",
		"chat-chat-module"
	],
	"./pages/chats/chats.module": [
		"./src/app/pages/chats/chats.module.ts",
		"chats-chats-module"
	],
	"./pages/confirm-transfer/confirm-transfer.module": [
		"./src/app/pages/confirm-transfer/confirm-transfer.module.ts",
		"pages-confirm-transfer-confirm-transfer-module"
	],
	"./pages/dietary/dietary.module": [
		"./src/app/pages/dietary/dietary.module.ts",
		"pages-dietary-dietary-module"
	],
	"./pages/donate/select-charity/select-charity.module": [
		"./src/app/pages/donate/select-charity/select-charity.module.ts",
		"common",
		"donate-select-charity-select-charity-module"
	],
	"./pages/friends/friends.module": [
		"./src/app/pages/friends/friends.module.ts",
		"friends-friends-module"
	],
	"./pages/onboarding/onboarding.module": [
		"./src/app/pages/onboarding/onboarding.module.ts",
		"pages-onboarding-onboarding-module"
	],
	"./pages/pending-requests/pending-requests.module": [
		"./src/app/pages/pending-requests/pending-requests.module.ts",
		"common",
		"pages-pending-requests-pending-requests-module"
	],
	"./pages/physical/physical.module": [
		"./src/app/pages/physical/physical.module.ts",
		"pages-physical-physical-module"
	],
	"./pages/settings/settings.module": [
		"./src/app/pages/settings/settings.module.ts",
		"settings-settings-module"
	],
	"./pages/signin/signin.module": [
		"./src/app/pages/signin/signin.module.ts",
		"pages-signin-signin-module"
	],
	"./pages/signup/signup.module": [
		"./src/app/pages/signup/signup.module.ts",
		"pages-signup-signup-module"
	],
	"./pages/sync-contacts/sync-contacts.module": [
		"./src/app/pages/sync-contacts/sync-contacts.module.ts",
		"pages-sync-contacts-sync-contacts-module"
	],
	"./pages/tabs/tabs.module": [
		"./src/app/pages/tabs/tabs.module.ts",
		"pages-tabs-tabs-module"
	],
	"./pages/user-profile/user-profile.module": [
		"./src/app/pages/user-profile/user-profile.module.ts",
		"user-profile-user-profile-module"
	],
	"./shared/components/new-group-modal/new-group-modal.module": [
		"./src/app/shared/components/new-group-modal/new-group-modal.module.ts",
		"shared-components-new-group-modal-new-group-modal-module"
	],
	"./terms-and-conditions/terms-and-conditions.module": [
		"./src/app/terms-and-conditions/terms-and-conditions.module.ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;